import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
// MUI
import { IconButton, Typography, Box, List, ListItem, ListItemText, ListItemIcon, ListItemSecondaryAction, Badge, Button } from '@mui/material';
import { NotificationsOutlined } from '@mui/icons-material';
import Dropdown from 'components/Dropdown/Dropdown';
import { NotificationIcon } from './NotificationIcon';
// styles
import useStyles from './styles';
import { Link, useNavigate } from 'react-router-dom';
import clsx from 'clsx';
import NotificationsRedux from 'redux/actions/notifications';
import dayjs from 'dayjs';

export default function NotificationsList() {
    const classes = useStyles();
    const { notifications } = useSelector(({ notifications }) => ({ notifications }));
    const navigate = useNavigate();
    const dispatch = useDispatch();

    async function handleAction(notification) {
        dispatch(NotificationsRedux.read(notification));

        if (notification.type === 'CreditUpdate') {
            navigate('/');
        } else if (notification.type === 'IRSUpdate') {
            navigate('/status');
        } else if (notification.type === 'DocumentsNeeded') {
            navigate('/documents');
        }
    }

    return (
        <Dropdown
            title={
                <IconButton sx={{ marginRight: 2, marginLeft: 1 }}>
                    <Badge invisible={notifications.unread === 0} badgeContent={notifications.unread} color="primary">
                        <NotificationsOutlined sx={{ fontSize: 34 }} />
                    </Badge>
                </IconButton>
            }
        >
            <Box className={classes.notificationBox}>
                <Box className={classes.notificationHeader}>
                    <Typography>Notifications</Typography>
                    <Link to="/notifications">
                        <Button color="secondary">View All</Button>
                    </Link>
                </Box>
                {notifications.items.length === 0 && (
                    <Box sx={{ padding: 2 }}>
                        <Typography variant="font3" sx={{ fontWeight: '200' }}>
                            You have no notifications.
                        </Typography>
                    </Box>
                )}
                {notifications.items.length > 0 ? (
                    <List className={classes.notificationList}>
                        {notifications.items.map((notification, i) => {
                            return (
                                <ListItem
                                    className={clsx({
                                        [classes.unread]: !notification.readAt,
                                    })}
                                    button
                                    onClick={() => handleAction(notification)}
                                    key={`noti-${i}`}
                                >
                                    <ListItemIcon>
                                        <Box className={classes.notificationIconContainer}>
                                            <NotificationIcon type={notification.type} />
                                        </Box>
                                    </ListItemIcon>
                                    <ListItemText
                                        primary={notification.meta.title}
                                        secondary={notification.meta.body}
                                        classes={{
                                            primary: classes.notificationPrimary,
                                            secondary: classes.notificationSecondary,
                                        }}
                                    />
                                    <ListItemSecondaryAction>
                                        <Typography variant="font5" sx={{ fontWeight: '200' }}>
                                            {dayjs(notification.createdAt).format('MMM DD')}
                                        </Typography>
                                    </ListItemSecondaryAction>
                                </ListItem>
                            );
                        })}
                    </List>
                ) : null}
            </Box>
        </Dropdown>
    );
}
